export const arcViewHeight56 = 56;
export const arcViewWidth375 = 375;

export const viewHeight293 = 293;
export const viewWidth1200 = 1200;

export const viewHeight335 = 335;
